import React from "react";
import ObjectFields from "./ObjectFields";

export const SchemaEditor = ({ schema, value, onChange }) => (
    <ObjectFields schema={schema.fields} value={value} onChange={onChange} depth={0} />
);

export default SchemaEditor;
